import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  darkColor: {
    color: theme.palette.common.black,
  },
  secondaryColor: {
    color: '#FFFFFF',
  },
  gradientStat: {
    fontSize: '4rem',
    fontWeight: '500',
    background: 'linear-gradient(45deg, #7833FF 0%, #D6246E 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    textFillColor: 'transparent',
    display: 'inline-block',
  },
  infoContent: {
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-evenly',
    },
  },
  infoBox: {
    textAlign: 'center',
    color: theme.palette.common.black,
  },
  divider: {
    backgroundColor: theme.palette.common.white,
    marginBottom: theme.spacing(4),
  },
  carouselSection: {
    padding: theme.spacing(6, 0),
    backgroundColor: '#FFFF',
    color: '#000',
  },
  statSection: {
    padding: theme.spacing(6, 0),
    backgroundColor: '#F8F8F8',
    color: '#000',
  },
  carouselRoot: {
    marginTop: theme.spacing(4),
    padding: 0,
  },
  carousel: {
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0, 14),
    },

    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(0, 35),
    },

    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(0, 46),
    },
  },
  carouselItem: {
    textAlign: 'center',
    padding: theme.spacing(0, 10),
  },
  carouselContent: {
    '& img': {
      display: 'block',
      maxWidth: '100%',
    },

    '& p': {
      padding: theme.spacing(2),
      opacity: 0,
      backgroundColor: '#F1B19F',
      transition: `opacity 250ms ${theme.transitions.easing.easeInOut}`,
    },

    '&:hover': {
      '& p': {
        opacity: 1,
      },
    },
  },
  button: {
    backgroundColor: ' #7833FF',
    color: theme.palette.common.white,
    textTransform: 'none',
    borderRadius: 35,
    padding: theme.spacing(1.5, 3),

    '&:hover': {
      backgroundColor: ' #5F29CC',
    },
  },
}));
